// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atom } from 'jotai'
import CompanionState from "@/lib/types/atoms/companionState";

// lib files
import { SearchResults } from '@/lib/types/search/results'

const searchResultsAtom = atom<SearchResults | null>(null)
const searchResultsStatus = atom<CompanionState>(CompanionState.NotLoaded)

export { searchResultsAtom, searchResultsStatus }
